import Head from 'next/head'

export default function WebpageJsonLd ({ name, description, image }) {
  const jsonld = `{
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": ${JSON.stringify(name)},
    "description": ${description ? JSON.stringify(description) : null},
    "thumbnailUrl": "${image || null}",
    "publisher": {
      "@type": "Organization",
      "name": "Sendung verpasst?",
      "legalName": "Sendung verpasst UG (haftungsbeschränkt)",
      "url": "${process.env.NEXT_PUBLIC_JSON_LD_ORGANISARTION_URL}",
      "logo": "${process.env.NEXT_PUBLIC_JSON_LD_ORGANISARTION_LOGO}"
    }
  }`

  return (
    <Head>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: jsonld }}
        key='jsonld-webpage'
      />
    </Head>
  )
}
